module.exports = __webpack_public_path__ + "static/media/submit_ld_icon.e44c4f6f.svg";